var Chart = require("chart.js");

$(document).ready(function (e) {
  if ($(".FundPage").length > 0) {
    var chart_loader = $(".FundPage").find(".loader");
    var allocation_chart = $(".allocation-chart__canvas canvas");
    var allocation_chart_data = {};
    var allocation_chart_object = null;
    if (allocation_chart.length > 0) {
      allocation_chart_data = JSON.parse(allocation_chart.attr("data-json"));

      allocation_chart_object = new Chart(allocation_chart, {
        type: "pie",
        options: {
          legend: {
            position: "left",
            labels: {
              fontFamily: "Inter",
              fontSize: 14,
              usePointStyle: true,
            },
          },
          onResize: function (chart, size) {
            if (size.width <= 450) {
              chart.options.legend.position = "bottom";
              chart.options.maintainAspectRatio = false;
              chart.canvas.parentNode.style.height = "220px";
            } else {
              chart.options.legend.position = "left";
              chart.options.maintainAspectRatio = true;
              chart.canvas.parentNode.style.height = "auto";
            }
          },
        },
        data: {
          labels: allocation_chart_data.Labels,
          datasets: [
            {
              data: allocation_chart_data.Values,
              backgroundColor: allocation_chart_data.Colours,
            },
          ],
        },
      });

      if (allocation_chart.outerWidth() <= 450) {
        allocation_chart_object.options.legend.position = "bottom";
        allocation_chart_object.options.maintainAspectRatio = false;
        allocation_chart_object.canvas.parentNode.style.height = "220px";
      }
    }

    var pricing_chart = $(".pricing-chart");
    var pricing_table = $(".pricing-table");
    var pricing_chart_data = {};
    var pricing_chart_object = null;
    var pricing_chart_from_date = $('.pricing form [name="From"]');
    var pricing_chart_to_date = $('.pricing form [name="To"]');
    var pricing_chart_view = $('.pricing form [name="View"]');
    if (pricing_chart.length > 0) {
      // Fetch on load
      get_pricing();

      // Fetch on form field change
      $(".pricing form").on("change", "input, select", function (e) {
        get_pricing();
      });

      // Fetch on form field change
      $(".pricing form .download-csv").on("click", function (e) {
        var url = pricing_chart.attr("data-endpoint");

        if (
          pricing_chart_from_date.length > 0 &&
          pricing_chart_from_date.val()
        ) {
          url += "?From=" + pricing_chart_from_date.val();
        }

        if (pricing_chart_to_date.length > 0 && pricing_chart_to_date.val()) {
          url += "&To=" + pricing_chart_to_date.val();
        }

        url += "&View=csv";

        window.location = url;
      });

      /**
       * Call our endpoint for more pricing data
       * Simple fetch via Ajax with chained rendering
       **/
      function get_pricing() {
        var url = pricing_chart.attr("data-endpoint");

        if (
          pricing_chart_from_date.length > 0 &&
          pricing_chart_from_date.val()
        ) {
          url += "?From=" + pricing_chart_from_date.val();
        }

        if (pricing_chart_to_date.length > 0 && pricing_chart_to_date.val()) {
          url += "&To=" + pricing_chart_to_date.val();
        }

        if (pricing_chart_view.length > 0 && pricing_chart_view.val()) {
          url += "&View=" + pricing_chart_view.val();
        }

        chart_loader.show();
        pricing_chart.hide();
        pricing_table.hide();

        $.ajax({
          type: "GET",
          url: url,
          success: function (response) {
            render_pricing(response);
          },
        });
      }

      /**
       * Render our fetched pricing data
       * This is the guts of our display functionality
       **/
      function render_pricing(response) {
        switch (pricing_chart_view.val()) {
          /**
           * Chart mode
           **/
          case "chart":
            pricing_chart.show();
            pricing_table.hide();
            chart_loader.hide();

            var data = JSON.parse(response);

            if (pricing_chart_object) {
              pricing_chart_object.destroy();
            }

            var yAxes_ticks = [];

            pricing_chart_object = new Chart(pricing_chart, {
              type: "line",
              options: {
                legend: {
                  display: false,
                },
                scales: {
                  yAxes: [
                    {
                      scaleLabel: {
                        fontFamily: "Inter",
                        fontSize: 16,
                        display: true,
                        labelString: "Price",
                      },
                      ticks: {
                        fontFamily: "Inter",
                        fontSize: 12,
                        maxTicksLimit: 8 /*,
												// This results in multiple labels of the same [rounded] value
												userCallback: function(label, index, labels){
													var number = Number(Math.round(label+'e2')+'e-2');
													var string = String(number);
													var dp = string.split('.')[1].length;

													// Add placeholder zeros if needed
													if (dp == 1){
														string += '0';
													} else if (dp == 0){
														string += '00';
													}

													return string;
												}
												*/,
                      },
                    },
                  ],
                  xAxes: [
                    {
                      type: "time",
                      distribution: "linear",
                      autoSkip: false,
                      time: {
                        unit: "day", // Or "month", "week", depending on your data granularity
                        tooltipFormat: "D MMM YYYY", // Tooltip format
                        displayFormats: {
                          day: "D MMM YYYY", // Tick label format
                        },
                      },
                      scaleLabel: {
                        fontFamily: "Inter",
                        fontSize: 16,
                        display: true,
                        labelString: "Date",
                      },
                      ticks: {
                        fontFamily: "Inter",
                        fontSize: 12,
                      },
                    },
                  ],
                },
              },
              data: {
                labels: data.Labels,
                datasets: [
                  {
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: "rgba(253, 136, 42, 0.4)",
                    borderColor: "rgba(253, 136, 42, 1)",
                    borderCapStyle: "round", // butt, square
                    pointHoverRadius: 1,
                    label: "",
                    data: data.Values,
                  },
                ],
              },
            });

            break;

          /**
           * Table mode
           **/
          case "table":
            pricing_chart.hide();
            chart_loader.hide();
            pricing_table.show();
            pricing_table.html(response);
            break;

          default:
            pricing_chart.hide();
            pricing_table.hide();
            chart_loader.hide();
            alert("Unknown view type");
        }
      }
    }
  }
});
